import { getExplainInfo } from '@home/services/studio';
import { Effect, Reducer } from 'umi';
export const namespace = 'studio';

export type TExplainInfo = {
  [key: string]: {
    value_en: string;
    value_cn: string;
  };
}

type TExplainInfoItem = {
  key: string;
  value_en: string;
  value_cn: string;
}

export interface IStudioModelStateType {
  // 页面类型 'studio' | 'game'
  frameType: string;

  // 浮窗信息
  explainInfo: TExplainInfo;
}

export interface ItudioModelType {
  namespace: string;
  state: IStudioModelStateType;
  effects: {
    setFrameType: Effect;
    getExplainInfo: Effect;
  };
  reducers: {
    save: Reducer<IStudioModelStateType>;
  };
}

const studioModel: ItudioModelType = {
  namespace,
  state: {
    frameType: '',
    explainInfo: {}
  },

  effects: {
    // 设置框架类型
    *setFrameType({ payload }, { put }) {
      yield put({
        type: "save",
        payload: {
          frameType: payload,
        }
      });
    },
    // 获取指标说明
    *getExplainInfo({ payload }, { put }) {
      try {
        const res: { rows: TExplainInfoItem[]; } = yield getExplainInfo(payload.params);
        const obj: TExplainInfo = {};
        const result = res?.rows || [];
        if (result.length > 0) {
          result.forEach((item: TExplainInfoItem) => {
            const { key, value_en, value_cn, ...rest } = item || {};
            obj[key] = {
              value_en,
              value_cn,
              ...rest
            };
          });
        }
        yield put({
          type: "save", payload: {
            explainInfo: obj
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  reducers: {
    save(state: IStudioModelStateType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
};

export default studioModel;
